import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { AsyncActions } from './language-assignments.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const languageAssignmentsFeatureKey = 'languageAssignments';

export interface LanguageAssignmentsState extends EntityState<any>, AsyncActionState {
    locations: any;
    english: boolean;
    spanish: boolean;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>({
    selectId: (languageAssignments: any) => languageAssignments.id,
    sortComparer: null,
});

export const initialState: LanguageAssignmentsState = adapter.getInitialState({
    locations: [],
    english: true,
    spanish: false,
    ...asyncActionState.initial,
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const languageAssignmentsReducer = withLoadables<LanguageAssignmentsState>({
    loadActions,
    successActions,
    errorActions,
})(
    initialState,
    on(ManagementBaseActions.initLanguageAssignments, (state, action) => ({
        ...initialState,
    })),
);
